import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DatabaseUser } from 'src/modules/database/shared/database-user.entity';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from "../../models/project-planning-tools.model";
import { CalendarRole } from '../../netgen/CalendarRole';
import { ProjectPlanningService } from '../../services/project-planning.service';

@Component({
    selector: 'app-edit-calendar-roles',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCalendarRolesComponent extends AdminBaseListComponent<CalendarRole> {

    service = inject(ProjectPlanningService);

    definition = ProjectPlanningTools.definitionCalendarRole;

    users: DatabaseUser[];

    async initAdditionalData(): Promise<void> {
        this.users = await this.service.getActiveUsers();
    }

    getTable(): TableData {
        return this.app.tTable("entity.CalendarRole.fields", new TableData([
            new TableColumn("color", "", TableCellType.color, 1),
            new TableColumn("title", "", TableCellType.string, 50),
            new TableColumn("responsibleId", "", TableCellType.string, 30)
        ], this.listData.map(o => new TableRow(Objects.toString(o.id), o, {
            color: o.color,
            title: o.title,
            responsibleId: this.users.find(item => item.id == o.responsibleId)?.getFullName() ?? ""
        })), ["title"]));
    }

}
